const C = require("../constants");
const initial_data = {
    open: false,
    product: {
        id:null,
        name: '',
        sale_price: 0,
        purchase_price: 0,
        tax_price: 0,
        category: null,
        provider: null,
        tax: null,
        active: true,
        visible: false,
        product_type: '',
        stock: false
    }
};

function ProductDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.PRODUCT_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ProductDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductDialogReducer.js